.line_icon_smaller {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}

.line_icon_smaller_eval {
    .line_icon_smaller();
    margin-right: 11px;
    transform: translate(0, -3px);
}

.evalPercentBox {
    background-color: #f9fafb;
    border-radius: 15px;
    width: 50px;
    height: 42px;
    margin-right: 8px;
    transform: translate(0px, 0px);
}
.line_icon {
    width: 50px;
    height: 20px;
    margin-right: 8px;
}
.line_text {
    font-family: Hanken Grotesk;
    font-size: 16px;
    font-weight: normal;
}

.inner_title {
    font-family: Hanken Grotesk;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 8px;
}
.round_border_container {
    border: 1px solid #eceef2;
    border-width: 1px 5px 1px 1px;
    border-radius: 8px 8px 0px 8px;
    overflow-y: auto;
}
.prework_list {
    border: 1px solid #eceef2;
    border-radius: 8px;
    padding: 8px 10px;
    margin: 10px;
    width: calc(100% - 20px);
}
.steps_list {
    border: 1px solid #eceef2;
    border-radius: 8px;
    padding: 8px 10px;
    margin: 10px;
    width: calc(100% - 20px);
}

.steps_list_eval {
    > :first-child {
        margin-top: 0px;
        margin-bottom: 15px !important;
    }

    border: 1px solid #eceef2;
    border-radius: 8px;
    padding: 8px 10px;
    margin: 10px;
    width: calc(100% - 20px);
}

.back_to_workstreams {
    background-color: #243a5c;
    height: 40px;
    border-radius: 15px 0 0 0;
    color: white;
    font-family: 'Lust Text', serif !important;
    font-size: 16px;
    font-weight: 300;
    font-style: italic;
    padding: 8px 10px;
    margin: 0px;
    width: calc(100% + 5px);
}
.saved_outputs {
    border-top: 2px dashed #eceef2;
    height: 44px;
}

.is_var_saved {
    margin-left: 4px;
    font-family: LustTextMedium;
    font-size: 16px;
    font-weight: bold;
    background-color: #ededed;
    color: #b4b6ba;
    width: 34px;
    height: 27px;
    font-style: italic;
    text-align: center;
    vertical-align: middle;
    border-radius: 12px;
    cursor: pointer;
}

.back_button {
    position: relative;
    top: 1px;
    height: 24px;
    width: 24px;
    background-color: #2075f4;
    border-radius: 8px;
    border: none;
    &:hover {
        background-color: #1864c6;
        transform: scale(1.1);
    }
    &:active {
        background-color: #1e52a1;
        transform: scale(1);
    }
    transition: all 0.2s ease;
    margin-right: 12px;
    z-index: 10;
}

.dropdownItem {
    font-family: Hanken Grotesk;
    font-size: 14px;
    font-weight: normal;
}
